import { FullLayout } from '@/components/layout/FullLayout'
import { AgentDock } from '@/features/page_agent/dock/components/AgentDock'

/** The authenticated full layout: the app chrome, then the Theragenie dock after `<main>`. */
export function AuthFullLayout() {
  return (
    <>
      <FullLayout />
      <AgentDock />
    </>
  )
}
